/**
 * Application constants
 */

// Date and time constants
export const DATE_CONSTANTS = {
    /** Number of days to show relative time instead of absolute date */
    RELATIVE_TIME_THRESHOLD_DAYS: 3,
    /** Cache expiration time for posts in milliseconds */
    POSTS_CACHE_EXPIRATION_MS: 5 * 60 * 1000, // 5 minutes
    /** Cache expiration time for ads in milliseconds */
    ADS_CACHE_EXPIRATION_MS: 30 * 60 * 1000, // 30 minutes
} as const;

// Pagination constants
export const PAGINATION_CONSTANTS = {
    /** Default number of posts per page */
    DEFAULT_POSTS_PER_PAGE: 20,
    /** Maximum number of posts to load at once */
    MAX_POSTS_PER_LOAD: 50,
    /** Default page size for notifications */
    DEFAULT_NOTIFICATIONS_PER_PAGE: 10,
} as const;

// Cache constants
export const CACHE_CONSTANTS = {
    /** Cache names for different data types */
    CACHE_NAMES: {
        POSTS: '24horas-posts',
        IMAGES: '24horas-images',
        ADS: '24horas-ads',
        OPINIONS: '24horas-opinions',
        OPINION_IMAGES: '24horas-images-opinions',
    },
    /** Maximum number of cached items */
    MAX_CACHED_ITEMS: 1000,
    /** Maximum cache size in MB */
    MAX_CACHE_SIZE_MB: 100,
} as const;

// UI constants
export const UI_CONSTANTS = {
    /** Debounce delay for search input in milliseconds */
    SEARCH_DEBOUNCE_MS: 300,
    /** Animation duration for transitions in milliseconds */
    TRANSITION_DURATION_MS: 300,
    /** Scroll position restoration delay in milliseconds */
    SCROLL_RESTORE_DELAY_MS: 100,
    /** Maximum number of history entries to keep */
    MAX_HISTORY_ENTRIES: 15,
} as const;

// API constants
export const API_CONSTANTS = {
    /** Request timeout in milliseconds */
    REQUEST_TIMEOUT_MS: 30000, // 30 seconds
    /** Maximum number of retry attempts */
    MAX_RETRY_ATTEMPTS: 3,
    /** Retry delay in milliseconds */
    RETRY_DELAY_MS: 1000,
} as const;

// App version constants
export const VERSION_CONSTANTS = {
    /** Version that requires notification settings reset */
    NOTIFICATION_RESET_VERSION: 10012,
} as const;
